import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment';
import {BehaviorSubject, Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {map, tap} from 'rxjs/operators';
import {OrganisationDisciplineUser} from '../models/models.lib';
import {ApiService} from '../api/api.service';
const { apiUrl } = environment;

export abstract class CasiOrganisationDisciplineUserService extends BehaviorSubject<Array<any>>{
  public loading: boolean = false;

  constructor(
    private http: HttpClient,
  ) {
    super([]);
  }

  public query(organisationDisciplineId: number): void {
    this.fetch(organisationDisciplineId).subscribe((x) => {
      return super.next(x);
    });
  }

  protected fetch(organisationDisciplineId: number): Observable<OrganisationDisciplineUser[]> {
    this.loading = true;

    return this.http.get(encodeURI(`${apiUrl}/organisation/discipline/user/all/${organisationDisciplineId}`))
      .pipe(
        map((response: any, i) => {
          return <OrganisationDisciplineUser[]>response;
        }),
        map(r => r.map(x => OrganisationDisciplineUser.create(x))),
        tap(() => (this.loading = false))
      )
  }
}

@Injectable({
  providedIn: 'root'
})
export class OrganisationDisciplineUserService extends CasiOrganisationDisciplineUserService{
  constructor(
    http: HttpClient,
    private apiService: ApiService
  ) {
    super(http)
  }

  get(organisationDisciplineId: number) {
    return this.apiService.getHttpCall(`organisation/discipline/user/all/${organisationDisciplineId}`, 'get');
  }

  add(p: any): Promise<any> {
    return this.apiService.postHttpCallAsPromise('organisation/discipline/user', p, 'add');
  }

  update(id: number, dataItem: any): Promise<any> {
    return this.apiService.putHttpCallAsPromise(`organisation/discipline/user/${id}`, dataItem , 'update');
  }

  destroy(id: number): Promise<any> {
    return this.apiService.deleteHttpCallAsPromise(`organisation/discipline/user/${id}` , 'destroy');
  }
}
